import { ActionEnum } from '../actions/types/orderActions.types';

export type ModalState = {
  show: boolean;
  modal?: ActionEnum;
};

export const initialModalState: ModalState = {
  show: false,
  modal: undefined,
};
